<template>
  <Dropdown>
    <template #button>
      <button class="text outline-none">
        <avatar></avatar>
      </button>
    </template>
    <template #menuItem>
      <DropdownItem @click="" class="hover:bg-indigo-100 dark:hover:bg-indigo-900 px-4">
        <span class="font-bold">
          {{ username }}
        </span>
      </DropdownItem>
      <!-- <DropdownItem
        @click="onProfile"
        class="justify-center hover:bg-indigo-100 dark:hover:bg-indigo-900"
      >
        <span class="font-bold"> 个人中心 </span>
      </DropdownItem> -->
      <DropdownItem @click="onSignOut" class="justify-center hover:bg-indigo-100 dark:hover:bg-indigo-900">
        <span class="font-bold"> 退出登录 </span>
      </DropdownItem>
      <!-- <DropdownItem @click="onSubscribe" class="justify-center px-1">
        <button class="third-btn w-full">升级套餐</button>
      </DropdownItem> -->
    </template>
  </Dropdown>
  <Subscription ref="subRef" />
</template>
<script setup lang="ts">
import {
  Dropdown,
  DropdownItem,
} from "@/components/ui/dropdown/dropdown-helper";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import avatar from "@/assets/icons/avatar.svg";
import { logoutAPI } from "@/api/auth/auth";
import { useToken } from "@/hooks/useToken";
import { storeToRefs } from "pinia";

const authStore = useAuthStore();
const { username } = storeToRefs(authStore);
const { removeToken } = useToken();
const router = useRouter();
const onProfile = () => {
  router.push("/profile");
};

const onSignOut = () => {
  console.log("sign out");
  logoutAPI().then(() => {
    removeToken();
    authStore.clearUserInfo(); // 清除所有用户信息包括角色
    router.push("/login");
    // refresh cache
    setTimeout(() => {
      window.location.reload();
    }, 100);
  });
};
</script>
